import { IMultiSuggestResult, IMessageInfo } from '@cian/geosuggest-widget';
import { EFlatRoomCounts } from '../../common/utils/types';

/** Саджест адресов **/
export interface IGeoSuggestData {
  isFetching: boolean;
  error?: IMessageInfo;
  suggestData?: IMultiSuggestResult;
}

export interface IFlatArea {
  /** Площадь **/
  area: number;
  /** Кол-во комнат **/
  roomsCount: number;
}

export interface IFlatAreasSuggest {
  /** Саджест площади квартир по комнатам **/
  flatAreas?: IFlatArea[];
}

/** Payload для установки ошибки */
export enum ECurrentErrorField {
  none = '',
  address = 'address',
  roomsCount = 'roomsCount',
  area = 'area',
  houseArea = 'houseArea',
  landArea = 'landArea',
  flatNumber = 'flatNumber',
  section = 'section',
}

/** Тултип для вывода ошибки **/
export interface IErrorTooltip {
  currentErrorField: ECurrentErrorField;
  errorText: string;
}

export interface IFormFieldWithLabel {
  placeholder: string;
}

export interface IFormFieldErrorMessage {
  errorMessage?: string;
}

export interface IFormFieldValue<V> {
  value: V;
  selectedLabel: string;
  label: string;
}

export interface IFormFieldUI<V> {
  value: V | null;
  values: Record<string, IFormFieldValue<NonNullable<V>>>;
  onValueChange(value: V): void;
}

export enum ESuburbanEstimationCategory {
  LandSale = 'landSale',
  HouseSale = 'houseSale',
}

export enum EUnits {
  area = 'м²',
  sotki = 'сот.',
}

export interface INewbuildingSectionItem {
  label: string;
  value: number;
}

/** Стор формы добавления объекта в МД **/
export interface IFormFields {
  address: string;
  errorTooltip: IErrorTooltip;
  flatAreasSuggest: IFlatAreasSuggest;
  addressGeoSuggest: IGeoSuggestData;

  roomsCount?: EFlatRoomCounts;
  userSetRoomsCount: boolean;
  area?: number;
  userSetArea: boolean;
  flatNumber?: number;
  houseId?: number;

  landArea?: number;
  houseArea?: number;
  category?: ESuburbanEstimationCategory;

  newbuildingSection?: number;
  newbuildingSectionsList?: INewbuildingSectionItem[];

  isChatSubscribeActive: boolean;
}
